/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import socket from "../../assets/socketConnection";
import { socketServer } from "../../assets/socketConnection";
import { Select, Tag } from "antd";
import { selectNewRequestCities } from "../../redux/newRequest/newRequest.selectors";
import {
  fetchNewRequestCitiesAsync,
  setNewRequestSelectionLevel,
} from "../../redux/newRequest/newRequest.actions";
import { toPersianNum, toEnglishNum } from "../../assets/utils";
import { selectUserInfo } from "../../redux/user/user.selectors";
import {
  InputStyled,
  InputContainer,
  InputTextContainer,
  InputDateContainer,
  InputُTextAreaStyled,
  SelectBtnStyled,
  ImageInputStyled,
  ImageInputContainerStyled,
  UserTypesTextStyled,
  ImageInputWithImageStyled,
  Container,
  SubmitBtn,
  SubmitBtnContainer,
  AlertStyled,
} from "./userInfoPage.styles";
import MapLeftOverlay from "../../containerSmall/mapLeftOverlay/mapLeftOverlay.component";
const UserInfoPage = () => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const Cities = useSelector(selectNewRequestCities);
  const UserInformation = useSelector(selectUserInfo);
  const {
    status,
    birthday,
    address,
    mobile,
    gender,
    firstname,
    lastname,
    fathername,
    codemelli,
    cardmelli_img,
    company_detail,
    barbari_detail,
    member_type,
  } = UserInformation;
  // console.log("UserInformation",UserInformation)
  const [obj, setObj] = useState({
    firstname: firstname,
    lastname: lastname,
    fathername: fathername ? fathername : "",
    codemelli: codemelli,
    cardmelli_img: cardmelli_img ? cardmelli_img : "",
    mobile: mobile,
    address: {
      ostan: "",
      shahr: "",
      detail: address?.detail ? address?.detail : "",
    },
    birthday: {
      year: "",
      month: "",
      day: "",
    },
    gender: "",
    is_barbari: false,
    barbari_detail: {
      name: barbari_detail?.name ? barbari_detail?.name : "",
      tell: barbari_detail?.tell ? barbari_detail?.tell : "",
      address: barbari_detail?.address ? barbari_detail?.address : "",
      doc1: "",
      doc2: "",
      doc3: "",
    },
    is_company: false,
    company_detail: {
      name: company_detail?.name ? company_detail?.name : "",
      codemelli: company_detail?.codemelli ? company_detail?.codemelli : "",
      tell: company_detail?.tell ? company_detail?.tell : "",
      address: company_detail?.address ? company_detail?.address : "",
      doc1: "",
      doc2: "",
      doc3: "",
    },
  });
  console.log("UserInformation", UserInformation);
  const [selected, setSelected] = useState(false);
  const [userTypes, setUserTypes] = useState(member_type);
  const [selectedProv, setSelectedProv] = useState("");
  const [show, setShow] = useState(false);
  const [showC, setShowC] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const years = [];
  const month = [
    { value: "فروردین", index: "1" },
    { value: "اردیبهشت", index: "2" },
    { value: "خرداد", index: "3" },
    { value: "تیر", index: "4" },
    { value: "مرداد", index: "5" },
    { value: "شهریور", index: "6" },
    { value: "مهر", index: "7" },
    { value: "آبان", index: "8" },
    { value: "آذر", index: "9" },
    { value: "دی", index: "10" },
    { value: "بهمن", index: "11" },
    { value: "اسفند", index: "12" },
  ];
  const days = [];
  for (var i = 1398; i >= 1330; i--) {
    years.push({ value: toPersianNum(i) });
  }
  for (var i = 1; i <= 31; i++) {
    days.push({ value: toPersianNum(i) });
  }
  useEffect(() => {
    console.log("UserInformation", obj.cardmelli_img);
    gender === "male" ? setGenderMale() : setGenderFemale();
  }, [UserInformation]);

  function tagRender(props) {
    const { label } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        style={{
          marginRight: 3,
          border: "transparent",
          backgroundColor: "transparent",
        }}
      >
        {label}
      </Tag>
    );
  }
  const setGenderFemale = () => {
    setObj({ ...obj, gender: "female" });
    setSelected(!selected);
  };
  const setGenderMale = () => {
    setObj({ ...obj, gender: "male" });
    setSelected(!selected);
  };
  useEffect(() => {
    status === 2 || status === 0 ? setDisabled(false) : setDisabled(true);
    dispatch(fetchNewRequestCitiesAsync(socket));
  }, []);
  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedProv(value);
    setObj({
      ...obj,
      address: { ...obj.address, ostan: value },
    });
  };
  const handleChangeCity = (value) => {
    console.log(`selected ${value}`);
    setObj({
      ...obj,
      address: { ...obj.address, shahr: value },
    });
  };
  const handleChanghMonth = (value) => {
    console.log(`selected ${value}`);
    setObj({
      ...obj,
      birthday: { ...obj.birthday, month: value },
    });
  };
  const handleChangeUserTypes = (value) => {
    console.log(`selected ${value}`);
    setUserTypes(value);
    switch (value) {
      case 1:
        setObj({ ...obj, is_company: true });
        break;
      case 2:
        setObj({ ...obj, is_barbari: true });
        break;
      default:
        break;
    }
  };

  const UploadImage = () => {
    console.log("formData");
    const fileInput = document.querySelector(".mellicard__image");
    const formData = new FormData();
    formData.append("file", fileInput?.files[0]);
    console.log("ax",fileInput?.files[0])
    const options = {
      method: "POST",
      body: formData,
    };
    fetch(`${socketServer}upload/docs`, options)
      .then((res) => res.json())
      .then((res) => {
        console.log("formData", res);
        setObj({ ...obj, cardmelli_img: res.image_filename });
      });
  };
  const CompleteProfileUser = () => {
    console.log(obj);
    if (obj.cardmelli_img) {
      socket.emit("complete_profile_users", obj);
    }
  };
  return (
    <Container className="delete__scrollbar">
      <InputContainer>
        <InputTextContainer>نوع کاربر</InputTextContainer>
        <Select
          disabled={disabled}
          onChange={handleChangeUserTypes}
          defaultValue={userTypes}
        >
          <Option value={0}>شخص حقیقی</Option>
          <Option value={1}>نماینده شرکت</Option>
          <Option value={2}>نماینده باربری</Option>
        </Select>
      </InputContainer>
      {userTypes === 1 && (
        <>
          <UserTypesTextStyled>اطلاعات شرکت</UserTypesTextStyled>
          <InputContainer>
            <InputTextContainer>نام شرکت</InputTextContainer>
            <InputStyled
              disabled={disabled}
              type="text"
              value={obj.company_detail?.name}
              onChange={(e) =>
                setObj({
                  ...obj,
                  company_detail: {
                    ...obj.company_detail,
                    name: e.target.value,
                  },
                })
              }
            />
          </InputContainer>
          <InputContainer>
            <InputTextContainer>شماره اقتصادی</InputTextContainer>
            <InputStyled
              disabled={disabled}
              type="text"
              value={toPersianNum(obj.company_detail?.codemelli)}
              onChange={(e) =>
                setObj({
                  ...obj,
                  company_detail: {
                    ...obj.company_detail,
                    codemelli: toEnglishNum(e.target.value),
                  },
                })
              }
            />
          </InputContainer>
          <InputContainer>
            <InputTextContainer>شماره تلفن</InputTextContainer>
            <InputStyled
              disabled={disabled}
              type="text"
              value={toPersianNum(obj.company_detail?.tell)}
              onChange={(e) =>
                setObj({
                  ...obj,
                  company_detail: {
                    ...obj.company_detail,
                    tell: toEnglishNum(e.target.value),
                  },
                })
              }
            />
          </InputContainer>
          <InputContainer>
            <InputTextContainer>آدرس</InputTextContainer>
            <InputُTextAreaStyled
              disabled={disabled}
              value={obj.company_detail?.address}
              placeholder="آدرس کامل"
              onChange={(e) =>
                setObj({
                  ...obj,
                  company_detail: {
                    ...obj.company_detail,
                    address: e.target.value,
                  },
                })
              }
            />
          </InputContainer>
          <UserTypesTextStyled>اطلاعات نماینده شرکت</UserTypesTextStyled>
        </>
      )}
      {userTypes === 2 && (
        <>
          <UserTypesTextStyled>اطلاعات باربری</UserTypesTextStyled>
          <InputContainer>
            <InputTextContainer>نام باربری</InputTextContainer>
            <InputStyled
              disabled={disabled}
              type="text"
              value={obj.barbari_detail?.name}
              onChange={(e) =>
                setObj({
                  ...obj,
                  barbari_detail: {
                    ...obj.barbari_detail,
                    name: e.target.value,
                  },
                })
              }
            />
          </InputContainer>
          <InputContainer>
            <InputTextContainer>شماره تلفن</InputTextContainer>
            <InputStyled
              disabled={disabled}
              type="text"
              value={toPersianNum(obj.barbari_detail?.tell)}
              onChange={(e) =>
                setObj({
                  ...obj,
                  barbari_detail: {
                    ...obj.barbari_detail,
                    tell: toEnglishNum(e.target.value),
                  },
                })
              }
            />
          </InputContainer>
          <InputContainer>
            <InputTextContainer>آدرس</InputTextContainer>
            <InputُTextAreaStyled
              disabled={disabled}
              value={obj.barbari_detail?.address}
              placeholder="آدرس کامل"
              onChange={(e) =>
                setObj({
                  ...obj,
                  barbari_detail: {
                    ...obj.barbari_detail,
                    address: e.target.value,
                  },
                })
              }
            />
          </InputContainer>
          <UserTypesTextStyled>اطلاعات نماینده باربری</UserTypesTextStyled>
        </>
      )}
      <InputContainer>
        <InputTextContainer>شماره تلفن</InputTextContainer>
        <InputStyled
          disabled={disabled}
          type="text"
          value={toPersianNum(obj.mobile)}
          onChange={(e) => setObj({ ...obj, mobile: e.target.value })}
        />
      </InputContainer>
      <InputContainer>
        <InputTextContainer>نام</InputTextContainer>
        <InputStyled
          disabled={disabled}
          type="text"
          value={obj.firstname}
          onChange={(e) => setObj({ ...obj, firstname: e.target.value })}
        />
      </InputContainer>
      <InputContainer>
        <InputTextContainer>نام خانوادگی</InputTextContainer>
        <InputStyled
          disabled={disabled}
          type="text"
          value={obj.lastname}
          onChange={(e) => setObj({ ...obj, lastname: e.target.value })}
        />
      </InputContainer>
      <InputContainer>
        <InputTextContainer>نام پدر</InputTextContainer>
        <InputStyled
          disabled={disabled}
          type="text"
          value={obj.fathername}
          onChange={(e) => setObj({ ...obj, fathername: e.target.value })}
        />
      </InputContainer>
      <InputContainer>
        <InputTextContainer>کدملی</InputTextContainer>
        <InputStyled
          disabled={disabled}
          type="text"
          maxLength={10}
          minLength={10}
          value={toPersianNum(obj.codemelli)}
          onChange={(e) =>
            setObj({ ...obj, codemelli: toEnglishNum(e.target.value) })
          }
        />
      </InputContainer>
      <InputContainer>
        <InputTextContainer>تاریخ تولد</InputTextContainer>
        <InputDateContainer>
          <Select
            disabled={disabled}
            className="c-pointer"
            tagRender={tagRender}
            style={{ width: "100%" }}
            defaultValue={toPersianNum(birthday?.day)}
            options={days}
            onChange={(e) =>
              setObj({
                ...obj,
                birthday: { ...obj.birthday, day: toEnglishNum(e) },
              })
            }
          />
          <Select
            disabled={disabled}
            className="c-pointer"
            style={{ width: "100%" }}
            onChange={handleChanghMonth}
            defaultValue={birthday?.month}
          >
            {month.map((months, index) => (
              <Option value={months.index}>{months.value}</Option>
            ))}
          </Select>
          <Select
            disabled={disabled}
            className="c-pointer"
            tagRender={tagRender}
            defaultValue={toPersianNum(birthday?.year)}
            style={{ width: "100%" }}
            options={years}
            onChange={(e) =>
              setObj({
                ...obj,
                birthday: { ...obj.birthday, year: toEnglishNum(e) },
              })
            }
          />
        </InputDateContainer>
      </InputContainer>
      <InputContainer>
        <InputTextContainer>جنسیت</InputTextContainer>
        <InputDateContainer>
          <SelectBtnStyled
            selected={selected}
            onClick={() => setGenderFemale()}
          >
            زن
          </SelectBtnStyled>
          <SelectBtnStyled selected={!selected} onClick={() => setGenderMale()}>
            مرد
          </SelectBtnStyled>
        </InputDateContainer>
      </InputContainer>
      <InputContainer>
        <InputTextContainer>استان</InputTextContainer>
        <Select
          disabled={disabled}
          onChange={handleChange}
          defaultValue={address?._ostan.provincename}
        >
          {Cities.map((prov, index) => (
            <Option value={prov._id}>{prov.provincename}</Option>
          ))}
        </Select>
        {/* <MapLeftOverlay dataType={1} show={show} /> */}
      </InputContainer>
      <InputContainer
        onClick={() => {
          dispatch(setNewRequestSelectionLevel(0));
          setShowC(true);
        }}
      >
        <InputTextContainer>شهر</InputTextContainer>
        <Select
          disabled={disabled}
          onChange={handleChangeCity}
          defaultValue={address?._shahr.shahrname}
        >
          {Cities.find((element) => element._id === selectedProv)?._city.map(
            (city, index) => (
              <Option value={city._id}>{city.shahrname}</Option>
            )
          )}
        </Select>
      </InputContainer>
      <InputContainer>
        <InputTextContainer>آدرس کامل</InputTextContainer>
        <InputُTextAreaStyled
          disabled={disabled}
          value={obj.address.detail}
          placeholder="آدرس کامل"
          onChange={(e) =>
            setObj({
              ...obj,
              address: { ...obj.address, detail: e.target.value },
            })
          }
        />
      </InputContainer>
      <InputContainer>
        <InputTextContainer>تصویر کارت ملی</InputTextContainer>
        <ImageInputContainerStyled cardmelli_img={obj.cardmelli_img}>
          {obj.cardmelli_img ? (
            <ImageInputWithImageStyled
              className="mellicard__image"
              url={`${socketServer}uploaded_documents/${obj.cardmelli_img}.jpg`}
              type="file"
            />
          ) : (
            <ImageInputStyled
              className="mellicard__image"
              accept="image/*"
              name="image"
              onChange={UploadImage}
              type="file"
            />
          )}
        </ImageInputContainerStyled>
      </InputContainer>
      <InputContainer>
        <InputTextContainer />
        {(status === 0 || status === 2) && (
          <SubmitBtn onClick={CompleteProfileUser}>ثبت</SubmitBtn>
        )}
        {status === 5 && (
          <AlertStyled>لطفا در انتظار تایید مدیر بمانید</AlertStyled>
        )}
      </InputContainer>
    </Container>
  );
};

export default UserInfoPage;
